// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4246ced1","455":"118ef8ea","977":"59880771"}[chunkId] + ".chunk.js";
};